import React from 'react'
import {EventBusContext, buildEventBusContextValue} from 'powtoon-commons/events/EventBusContext'
import {EventBus} from './EventBus'

interface EventBusProviderProps {
  eventBus: EventBus
}

export const EventBusProvider: React.FC<EventBusProviderProps> = ({children, eventBus}) => {
  const value = React.useMemo(() => buildEventBusContextValue(eventBus), [eventBus])
  
  return (
    <EventBusContext.Provider value={value} >
      {children}
    </EventBusContext.Provider >
  )
}
